// extracted by mini-css-extract-plugin
export default {"empty-messages":"empty-messages__3QnSb","empty-messages__text":"empty-messages__text__1Zn-m"};